import { Outlet } from 'react-router-dom';
import SiteHeader from '../components/portal/SiteHeader';

/** Public marketing shell for landing + login gate. */
export default function PublicLayout() {
  return (
    <div className="portal-shell">
      <SiteHeader />
      <main className="portal-main">
        <Outlet />
      </main>
    </div>
  );
}
